/**
 * Boolean-op type + display labels (Tier 2 Group A PR-C). Split
 * out from `path-ops.ts` so consumers that only need the type or
 * label dictionary (e.g. PropertiesPanel for the chip row) can
 * import without triggering paper.js's module-load canvas init.
 * The runtime — pathBoolean — lives in `path-ops.ts` and re-
 * exports these for callers that want everything at one import.
 */

export type BooleanOp = 'unite' | 'subtract' | 'intersect' | 'exclude';

/** Display labels for the PropertiesPanel chip row + tooltips. */
export const BOOLEAN_OP_LABELS: Record<BooleanOp, string> = {
  unite: 'Union',
  subtract: 'Subtract',
  intersect: 'Intersect',
  exclude: 'Exclude',
};
